module.exports = __webpack_public_path__ + "media/packs/images/panes/updates-f2b678f876b54c744a70011bffcd2e79.svg";